import _ from 'underscore';

import {
  AssetLibraryODataError,
  generateImagesWithAIAPIErrorProcessor,
  getAIGeneratedImageAPIErrorProcessor,
} from '../error-handling';

export const getAIGCRepository = ({ aigcODataService }) => {
  const generateImagesWithAIAsync = (userPrompt, skipBrandDetection = true) => {
    const promise = aigcODataService.generateImagesWithAIAsync(userPrompt, skipBrandDetection).then((res) => {
      const { TaskId } = res || {};
      return { taskId: TaskId };
    }).catch((err) => {
      const alError = new AssetLibraryODataError({
        message: `GenerateImagesWithAI api failed, status: ${err.status}, prompt: ${userPrompt}`,
        originError: err,
        errorProcessor: generateImagesWithAIAPIErrorProcessor,
      });
      // brand name detected, return the brand names
      if (alError.brandNameDetected) {
        return { taskId: null, brandNameDetected: true, brandNames: alError.brandNames };
      }
      throw alError;
    });
    return promise;
  };

  const getAIGeneratedImageTaskStatus = (taskId) => {
    const promise = aigcODataService.getAIGeneratedImageTaskStatus(taskId).then((res) => {
      const {
        Status: status, // InProgress, Failed, Completed
        Progress: progress,
        // TaskId: tid,
        RecommendedImages,
      } = res || {};
      const images = _.map(RecommendedImages, ({
        Id, Source, Url, Theme, ModelSource,
      }) => ({
        id: Id, source: Source, url: Url, theme: Theme, modelSource: ModelSource,
      }));

      if (status === 'Failed') {
        // throw an error with a UI predefined error code
        const error = new Error(`AIGenerateImagesTaskStatus api failed, taskId: ${taskId}`);
        error.errors = [{
          Code: 'AI_Generation_Failed',
        }];
        throw error;
      }

      const isTaskDone = progress >= 100 || status === 'Completed';

      return {
        taskId, status, progress, images, isTaskDone,
      };
    }).catch((err) => {
      throw new AssetLibraryODataError({
        message: `AIGenerateImagesTaskStatus api failed, status: ${err.status}, taskId: ${taskId}`,
        originError: err,
        errorProcessor: getAIGeneratedImageAPIErrorProcessor,
      });
    });
    return promise;
  };

  return {
    generateImagesWithAIAsync,
    getAIGeneratedImageTaskStatus,
  };
};
